module.exports = __webpack_public_path__ + "static/media/marketplace2.b3e85330.svg";